import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "components/common/Modal";
import { cancelArchive, confirmArchive } from "store/swList/swListActions";

interface IArchiveModal {
  swGuid: string,
}

const ArchiveModal: React.FC<IArchiveModal> = (props) => {
  const dispatch = useDispatch();
  const [reason, setReason] = useState<string>("");

  return (
    <Modal
      header="Archive Standard Work"
      controls={(
        <>
          <button
            className="primary-button"
            onClick={() => dispatch(confirmArchive({
              swGuid: props.swGuid,
              reason,
            }))}
          >
            Archive
          </button>
          <button
            className="secondary-button"
            onClick={() => dispatch(cancelArchive())}
          >
            Cancel
          </button>
        </>
      )}
      isOpen={true}
    >
      <p>
        <strong>Are you sure you want to archive this standard work?</strong>
        <br />
        <br />
        This will archive all versions of the standard work in the system.
        The standard work will be removed from the website and it will no longer be able to be updated.
      </p>
      <p>
        <strong>
          Reason for archiving the standard work
        </strong>
      </p>
      <textarea
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />
    </Modal>
  );
};

export default ArchiveModal;